import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { FontWeights } from 'builder/styles/typography'

export const WarningEmail = styled.span`
  color: ${Colors.Blue50};
  cursor: pointer;

  &:hover {
    color: ${Colors.Blue60};
  }

  & b {
    ${FontWeights.DemiBold};
  }
`
